import { useEffect, useCallback } from 'react';
import { trackPageView, trackEvent } from '../services/analytics';

// 基本的なAnalytics操作用フック
export const useAnalytics = () => {
  // ページビュー追跡
  const trackPage = useCallback((pageName) => {
    trackPageView(pageName);
  }, []);
  
  // カスタムイベント追跡
  const trackUserEvent = useCallback((eventName, parameters = {}) => {
    trackEvent(eventName, parameters);
  }, []);
  
  return { trackPage, trackUserEvent };
};

// 画面遷移の自動追跡用フック
export const usePageTracking = (currentScreen) => {
  const { trackPage } = useAnalytics();
  
  useEffect(() => {
    if (currentScreen) {
      // 画面名をより分かりやすい名前にマッピング
      const screenNames = {
        'home': 'ホーム画面',
        'appList': 'アプリ一覧画面',
        'app': 'アプリ詳細画面',
        'login': 'ログイン画面',
        'loading': '読み込み画面',
        'notFound': '404画面',
        'unauthenticated': '未認証画面'
      };
      
      const displayName = screenNames[currentScreen] || currentScreen;
      trackPage(displayName);
    }
  }, [currentScreen, trackPage]);
};

// 特定のアクション追跡用フック
export const useActionTracking = () => {
  const { trackUserEvent } = useAnalytics();
  
  // アプリ作成関連
  const trackAppCreationStart = useCallback(() => {
    trackUserEvent('app_creation_start');
  }, [trackUserEvent]);
  
  const trackAppCreationComplete = useCallback(() => {
    trackUserEvent('app_creation_complete');
  }, [trackUserEvent]);
  
  const trackAppCreationFailed = useCallback((errorReason) => {
    trackUserEvent('app_creation_failed', { error_reason: errorReason });
  }, [trackUserEvent]);
  
  // シェア関連
  const trackAppShare = useCallback((shareMethod = 'unknown') => {
    trackUserEvent('app_share', { share_method: shareMethod });
  }, [trackUserEvent]);
  
  // いいね関連
  const trackAppLike = useCallback(() => {
    trackUserEvent('app_like');
  }, [trackUserEvent]);
  
  const trackAppUnlike = useCallback(() => {
    trackUserEvent('app_unlike');
  }, [trackUserEvent]);
  
  // ログイン関連
  const trackUserLogin = useCallback((loginMethod = 'line') => {
    trackUserEvent('user_login', { login_method: loginMethod });
  }, [trackUserEvent]);
  
  const trackUserLogout = useCallback(() => {
    trackUserEvent('user_logout');
  }, [trackUserEvent]);
  
  return {
    trackAppCreationStart,
    trackAppCreationComplete,
    trackAppCreationFailed,
    trackAppShare,
    trackAppLike,
    trackAppUnlike,
    trackUserLogin,
    trackUserLogout
  };
};